import React from "react";
import styled from "styled-components";
import { Timeline_Sales_Session_Changes } from "./Timeline_Sales_Session_Changes";
import { Timeline_Sales_Session_Transition } from "./Timeline_Sales_Session_Transition";

const TimelineSalesStatus = styled.div`
    display: grid;
    gap: 0.25rem;
    min-width: 0;
    padding: 0.8rem 1rem;
    font-family: "fontMedium", sans-serif;
`;

// Displays an In Progress, Stalling, Agency, SASS, Lost or Update transition.
export const Timeline_Sales_Session_Status = (props) => {
    return (
        <TimelineSalesStatus data-testid="timeline-sales-session-status">
            <Timeline_Sales_Session_Transition statusChange={props.event.statusChange} />
            <Timeline_Sales_Session_Changes event={props.event} t={props.t} />
        </TimelineSalesStatus>
    );
};
